import React, {useEffect, Fragment} from 'react';
import CustomerCaseViewContent from "../../components/customer_case/CustomerCaseViewContent";
import {
    getCustomerCase,
} from "../../modules/admin/customer_case/customer_case";
import {useDispatch, useSelector} from "react-redux";
import qs from "qs";
import swal from "sweetalert";


const CustomerCaseView = ({cx, history}) => {
    const dispatch = useDispatch();

    /*const {customerCase,customerCaseCate,subscribeAuth,checkLoading,loading} = useSelector(({customer_case,loading}) =>({
        subscribeAuth:customer_case.subscribeCheck,
        customerCase: customer_case.customerCase,
        customerCaseCate: customer_case.customerCaseCate,
        deleteResult: customer_case.deleteResult,
        error: customer_case.error,
        loading: loading['customerCase/GET_CUSTOMER_CASE_LIST'],
        checkLoading: loading['customerCase/SUBSCRIBE_CHECK'],
    }))*/


    const {customerCase, subscribeAuth, error} = useSelector(({customer_case, auth, loading}) => ({
        customerCase: customer_case.customerCase.item,
        subscribeAuth: customer_case.subscribeCheck,
        error: customer_case.error,
        // loading: loading['adminCustomUserCount/GET_CUSTOM_USER_COU   NT'],
    }))

    useEffect(() => {

        if (subscribeAuth) {
            swal("컨설팅 아카데미 구독서비스가 없습니다").then(() => {
                history.goBack();
            })
        }

    }, [subscribeAuth]);

    useEffect(() => {
        console.log(customerCase);
        if (!customerCase) {
            swal("게시글이 없습니다.").then(() => {
                history.goBack();
            })
        }
    }, [customerCase])


    useEffect(() => {
        const {idx} = qs.parse(location.search, {
            ignoreQueryPrefix: true,
        });
        dispatch(getCustomerCase(idx))

    }, [])


    return (
        <div className="main_cont">
            {customerCase !== null && (
                <CustomerCaseViewContent item={customerCase} cx={cx}/>
            )}
        </div>
    );
};

export default CustomerCaseView;